<template>
  <div class="offer-confirm spacey-24">
    <div class="spacey-8">
      <div class="offer-confirm__title">
        {{ $t('You didn’t add any taxes to offer') }}
      </div>
      <div class="offer-confirm__text">
        {{ $t('Are you sure you want to submit offer without taxes information?') }}
      </div>
    </div>
    <div class="offer-confirm__actions spacex-8">
      <Button size="small" color="neutral" @click="context.emitter('submit-taxes')">
        {{ $t('Yes, submit') }}
      </Button>
      <Button size="small" @click="closeModal">
        {{ $t('Add taxes') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import { mapActions } from 'vuex';

  export default {
    name: 'NoTaxesConfirm',
    components: {
      Button,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          emitter: Function,
        }),
      },
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
      }),
    },
  };
</script>
